/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './autofill';
export * from './autosize';
export * from './text-field-module';



// WEBPACK FOOTER //
// ../../../../../src/cdk/text-field/public-api.ts